<div class="tab-pane">
  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
  <div class="px-2 pt-3">
    <button class="btn bg-g-lightGreen btn-sm pull-right" (click)="SaveRoleScreen()" *ngIf="screenList.length > 0">Save
      <i *ngIf="isLoader" class="fa fa-circle-o-notch fa-spin" style="font-size: .875rem; line-height: 1.5;"></i>
    </button>
    <button class="btn bg-g-lightGreen btn-sm m-b-20 mr-2 pull-right" (click)="addRole()" *ngIf="screenList.length > 0">Add
      Role</button>
  </div>
  <div class="br-none" *ngIf="screenList.length > 0">
    <div class="overflow-x mt-3 table-responsive box-shadow" [style.max-height.px]="myInnerHeight">
      <table class="table table-sm table-curved table-hover table-bordered">
        <thead class="box-shadow-none">
          <tr>
            <th>Screens</th>
            <th class="text-center" *ngFor="let role of userRoleList">{{role.displayTitle}}
              <span class="fa fa-pencil m-l-5 cursor-pointer" *ngIf="role.isDeleted && !isDisabled(role.id)"
                (click)="editRole(role.id, role.displayTitle)"></span>
              <span class="fa fa-trash m-l-5 cursor-pointer" *ngIf="role.isDeleted  && !isDisabled(role.id)"
                (click)="openDeleteDialog(role.id)"></span>
            </th>
          </tr>
        </thead>
        <tbody *ngFor="let parentMenu of screenList" [style.max-height.px]="myInnerHeight">
          <tr class="parent-menu" *ngIf="!parentMenu.parentId">
            <td>{{parentMenu.screenName}}</td>
            <td class="text-center" *ngFor="let role of userRoleList">
              <mat-slide-toggle [checked]="checkRoleScreen(role.id, parentMenu.id, roleScreenList)"
                (change)="updateRoleScreen(role.id, parentMenu.id, parentMenu.parentId, $event.checked)"
                [disabled]="isDisabled(role.id)">
              </mat-slide-toggle>
            </td>
          </tr>
          <ng-container *ngFor="let screen of parentMenu.children">
            <tr [ngClass]="(screen.children && screen.children.length>0) ? 'tr-highlight' : ''">
              <td>{{screen.screenName}}</td>
              <td class="text-center" *ngFor="let role of userRoleList">
                <mat-slide-toggle [checked]="checkRoleScreen(role.id, screen.id, roleScreenList)"
                  (change)="updateRoleScreen(role.id, screen.id, screen.parentId, $event.checked)"
                  [disabled]="isDisabled(role.id)">
                </mat-slide-toggle>
              </td>
            </tr>
            <ng-container *ngFor="let child of screen.children">
              <tr [ngClass]="(child.children && child.children.length>0) ? 'tr-highlight' : ''">
                <td class="pl-25">{{child.screenName}}</td>
                <td class="text-center" *ngFor="let role of userRoleList">
                  <mat-slide-toggle [checked]="checkRoleScreen(role.id, child.id, roleScreenList)"
                    (change)="updateRoleScreen(role.id, child.id, child.parentId, $event.checked)"
                    [disabled]="isDisabled(role.id)">
                  </mat-slide-toggle>
                </td>
              </tr>
              <ng-container *ngFor="let thirdChild of child.children">
                <tr [ngClass]="(thirdChild.children && thirdChild.children.length>0) ? 'tr-highlight' : ''">
                  <td class="pl-50">{{thirdChild.screenName}}</td>
                  <td class="text-center" *ngFor="let role of userRoleList">
                    <mat-slide-toggle [checked]="checkRoleScreen(role.id, thirdChild.id, roleScreenList)"
                      (change)="updateRoleScreen(role.id, thirdChild.id, thirdChild.parentId, $event.checked)"
                      [disabled]="isDisabled(role.id)">
                    </mat-slide-toggle>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="card-footer" *ngIf="screenList.length > 0">
      <button class="btn bg-g-lightGreen btn-sm pull-right" (click)="SaveRoleScreen()">Save
        <i *ngIf="isLoader" class="fa fa-circle-o-notch fa-spin" style="font-size: .875rem; line-height: 1.5;"></i>
      </button>
    </div>
  </div>
</div>
